import './page-header.scss';
import { Link } from 'react-router-dom';

export function PageHeader({ pageTitle, routes, ...rest }) {
  return (
    <div className="page-header">
      <p className="page-title">{pageTitle}</p>
      <div className="bread-crumb">
        {routes?.map((item, index) => {
          if (index !== routes.length - 1) {
            return (
              <Link to={item?.path}>
                {item?.name} <span>/ </span>
              </Link>
            );
          }
          return <span>{item?.name}</span>;
        })}
      </div>
    </div>
  );
}
export default PageHeader;
